import { Divider } from 'rc-menu';

export default Divider;
